import * as React from "react";
import type { SVGProps } from "react";
const SvgOmnichannel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M9.765 32.005c0-.431.35-.78.78-.78h43.542a.78.78 0 0 1 0 1.56H10.545a.78.78 0 0 1-.78-.78Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M5.238 28.327a3.678 3.678 0 1 0 0 7.356 3.678 3.678 0 0 0 0-7.356ZM0 32.005a5.24 5.24 0 1 1 10.478 0 5.24 5.24 0 0 1-10.478 0ZM58.761 28.327a3.678 3.678 0 1 0 0 7.356 3.678 3.678 0 0 0 0-7.356Zm-5.239 3.678a5.24 5.24 0 1 1 10.478 0 5.24 5.24 0 0 1-10.478 0ZM20.565 12.197a.78.78 0 0 1 1.066.286L43.397 50.19a.78.78 0 0 1-1.352.78L20.28 13.264a.78.78 0 0 1 .286-1.066Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M45.375 51.498a3.678 3.678 0 1 0 0 7.356 3.678 3.678 0 0 0 0-7.356Zm-5.24 3.678a5.24 5.24 0 1 1 10.48 0 5.24 5.24 0 0 1-10.48 0ZM18.623 5.146a3.678 3.678 0 1 0 0 7.356 3.678 3.678 0 0 0 0-7.356Zm-5.239 3.678a5.24 5.24 0 1 1 10.478 0 5.24 5.24 0 0 1-10.478 0ZM43.111 12.753a.78.78 0 0 1 .286 1.066L21.631 51.517a.78.78 0 0 1-1.352-.78l21.766-37.698a.78.78 0 0 1 1.066-.286Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M45.375 5.146a3.678 3.678 0 1 0 0 7.356 3.678 3.678 0 0 0 0-7.356Zm-5.24 3.678a5.24 5.24 0 1 1 10.479 0 5.24 5.24 0 0 1-10.478 0ZM18.623 51.498a3.678 3.678 0 1 0 0 7.356 3.678 3.678 0 0 0 0-7.356Zm-5.239 3.678a5.24 5.24 0 1 1 10.479 0 5.24 5.24 0 0 1-10.479 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M32 41.77c5.393 0 9.765-4.372 9.765-9.765 0-5.394-4.372-9.766-9.766-9.766-5.393 0-9.766 4.372-9.766 9.766 0 5.393 4.373 9.766 9.766 9.766Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32 23.02a8.986 8.986 0 1 0 0 17.97 8.986 8.986 0 0 0 0-17.97Zm-10.547 8.985c0-5.825 4.722-10.547 10.547-10.547 5.824 0 10.546 4.722 10.546 10.547S37.824 42.55 32 42.55c-5.825 0-10.547-4.721-10.547-10.546Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOmnichannel;
